export default "__VITE_ASSET__C2g6qS4m__"